import { render } from "./DiscountDetail.vue?vue&type=template&id=d00866e2&scoped=true"
import script from "./DiscountDetail.vue?vue&type=script&lang=js"
export * from "./DiscountDetail.vue?vue&type=script&lang=js"

import "./DiscountDetail.vue?vue&type=style&index=0&id=d00866e2&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d00866e2"]])

export default __exports__